import SapCountdown from "./components/SapCountdown"

const Sap = () => {
  return (
    <div>
      <SapCountdown />
    </div>
  )
}

export default Sap
